import { useEffect } from 'react';

import { BreadcrumbsOption, useStore } from '../store/useBreadcrumbs.store';

interface UseBreadcrumbsOptions {
  backBtnTitle?: string;
}

const useBreadcrumbs = (breadcrumbs: BreadcrumbsOption<string>[], backBtn?: boolean, options?: UseBreadcrumbsOptions) => {
  const setBreadcrumbs = useStore((state) => state.setBreadcrumbs);
  const handleSetBackBtn = useStore((state) => state.handleSetBackBtn);
  const setBackBtnTitle = useStore((state) => state.setBackBtnTitle);
  const resetBackBtnTitle = useStore((state) => state.resetBackBtnTitle);

  useEffect(() => {
    setBreadcrumbs(breadcrumbs);
    handleSetBackBtn(!!backBtn);

    if (options?.backBtnTitle) {
      setBackBtnTitle(options.backBtnTitle);
    } else {
      resetBackBtnTitle();
    }
  }, [backBtn, breadcrumbs, handleSetBackBtn, setBreadcrumbs, options?.backBtnTitle, setBackBtnTitle, resetBackBtnTitle]);
};
export default useBreadcrumbs;
